import React, {Component} from 'react';
import './ExternalLoginLink.css';

/**
 * Kudos https://www.lockedowndesign.com/social-media-colors/
 */
class ExternalLoginLink extends Component {
	render() {
		const {
			className,
			href,
			onClick,
			backgroundColour,
			icon,
			colour = '#fff',
			text,
			title,
			img
		} = this.props;

		return (
			<a
				className={`ExternalLoginLink ${className || ''}`}
				href={href}
				target="_self"
				rel="external"
				onClick={onClick}
				style={{
					backgroundColor: backgroundColour,
					color: colour
				}}
				title={title}>
				<span className="ExternalLoginLink-iconWrapper">
					{img ? <img src={img} alt="appleLogo" /> : <span className={`icon ${icon}`} />}
				</span>
				<span className="ExternalLoginLink-text">{text}</span>
			</a>
		);
	}
}

export default ExternalLoginLink;



// WEBPACK FOOTER //
// ./src/widgets/ExternalLoginLink.js